import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Navbar, ModalController } from 'ionic-angular';
import { IonicPage } from 'ionic-angular';
import { CoreProvider } from './../../providers/core-service/core-service';

import { Week } from '../../model/Week';

//rxjs
import 'rxjs/add/operator/filter';

import { DatePipe } from '@angular/common';
import { AlertController } from 'ionic-angular/components/alert/alert-controller';
import { WeekViewPage } from '../week-view/week-view';
import { ModalEditPage } from '../modal-edit/modal-edit';
import { legendaStati } from '../../constants/constants';
import { Messages } from '../../constants/messages';
import { FilterViewPage } from './../filter-view/filter-view';
import { NetworkConnectionProvider } from './../../providers/network-connection/network-connection';

/**
 * Generated class for the LoginPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
    selector: 'time-reporting',
    templateUrl: 'time-reporting.html'
})
export class TimeReportingPage {
    @ViewChild(Navbar) navBar: Navbar;

    private weekSubscription: any;
    week: Week = null;

    selected_week_element = [];

    labelWeek: string = 'Week';

    week_range: [Date, Date] = [null, null];
    week_days: Array<string> = [];

    user_data: any = {
        name: '',
        title: '',
        key: ''
    };
    hr_message = Messages.hr_confirm;

    showConfirm: boolean = false;
    showEdit: boolean = false;

    prevShow: boolean = true;
    nextShow: boolean = true;

    private onNext = true;
    private onPrev = true;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public network: NetworkConnectionProvider,
        private coreService: CoreProvider,
        private alertCtrl: AlertController,
        private modalCtrl: ModalController
    ) {

        this.week_range = this.coreService.getWeekRange();
        this.week_days = this.defineWeekDays();

    }

    /**
   * Swipe sposta tra le settimane
   */

    onSwipe(event: any) {
        if (event.direction == 4) {
            if (this.prevShow)
                this.moveToPreviousWeek();
        } else if (event.direction == 2) {
            if (this.nextShow)
                this.moveToNextWeek();
        }
    }

    loadActual() {
        this.coreService.getActualWeekUser(this.user_data.key);

        this.coreService.getofflineNextBlock().then(result => {
            this.nextShow = result;
        });

        this.coreService.getofflinePrevBlock().then(result => {
            this.prevShow = result;
        });
    }

    ionViewDidLoad() {
        this.setBackButtonAction();
    }

    //Method to override the default back button action
    setBackButtonAction() {
        this.navBar.backButtonClick = () => {
            //Write here wherever you wanna do
            let day = this.navParams.get('day');
            if (day) {
                this.navCtrl.setRoot(FilterViewPage, { day: this.week_range[0], activeIndex: this.navParams.get('activeIndex') });
            } else
                this.navCtrl.setRoot(WeekViewPage);
        }
    }

    ionViewWillEnter() {
        if (this.weekSubscription)
            this.weekSubscription.unsubscribe();

        // let week_endpoint = this.navParams.get('weekEndpoint'); //get week
        let user = this.navParams.get('userdata'); //get user

        this.user_data = user;

        let resetDate = this.navParams.get('resetDate');

        this.showConfirm = true;
        this.showEdit = true;

        this.weekSubscription = this.coreService.getWeekUser(this.user_data.key, resetDate).subscribe(week => {

            this.week = week;
            this.week_range = this.coreService.getWeekRange();
            this.week_days = this.defineWeekDays();

            if (this.coreService.getWeekDiffer() == 0) {
                this.labelWeek = 'Current Week';
            } else if (this.coreService.getWeekDiffer() < 0) {
                this.labelWeek = '' + this.coreService.getWeekDiffer() + ' Week';
            } else if (this.coreService.getWeekDiffer() > 0) {
                this.labelWeek = '+' + this.coreService.getWeekDiffer() + ' Week';
            }

            if (this.onNext) {
                this.coreService.getofflineNextBlock().then(result => {
                    this.nextShow = result;
                });
            }

            if (this.onPrev) {
                this.coreService.getofflinePrevBlock().then(result => {
                    this.prevShow = result;
                });
            }

        }, err => {
            //console.log(err);
        });

        this.network.checkConnection().subscribe(online => {
            if (online) {
                if (this.onNext)
                    this.coreService.getofflineNextBlock().then(result => {
                        this.nextShow = result;
                    });

                if (this.onPrev)
                    this.coreService.getofflinePrevBlock().then(result => {
                        this.prevShow = result;
                    });
            }
        });
    }

    ionViewWillLeave() {
        // enable the root left menu when leaving this page
        this.weekSubscription.unsubscribe();
    }

    moveToNextWeek(): void {
        this.onNext = true;
        this.prevShow = true;
        this.coreService.getNextWeekUser(this.user_data.key);

        this.coreService.setWeeksBinding();
    }

    moveToPreviousWeek(): void {
        this.onPrev = true;
        this.nextShow = true;
        this.coreService.getPrevWeekUser(this.user_data.key);

        this.coreService.setWeeksBinding();
    }

    checkUserPermission(): boolean {

        if (this.user_data.key == this.coreService.userKey) {
            return true;
        } else {
            return false;
        }

    }

    /**
     * Controlla le selezioni nei casi speciali
     * @param type 0 = single day, 1 = am, 2 = pm
     */
    checkSpecialElement(type: number, day_number?: number) {
        if (!this.checkUserPermission() || this.week.confirmed) return false;
        if (this.selected_week_element.length == 0) return false;

        if (type == 0) {
            let day = [day_number + '_am', day_number + '_pm'];
            if (this.selected_week_element.indexOf(day[0]) > -1 && this.selected_week_element.indexOf(day[1]) > -1) {
                return true;
            }
        } else if (type == 1) {
            let days = ['1_am', '2_am', '3_am', '4_am', '5_am', '6_am', '7_am'];
            let counter = 0;
            for (const key of days) {
                if (this.selected_week_element.indexOf(key) > -1) {
                    counter = counter + 1;
                }
            }
            if (counter == 7) {
                return true;
            }
        } else if (type == 2) {
            let days = ['1_pm', '2_pm', '3_pm', '4_pm', '5_pm', '6_pm', '7_pm'];
            let counter = 0;
            for (const key of days) {
                if (this.selected_week_element.indexOf(key) > -1) {
                    counter = counter + 1;
                }
            }
            if (counter == 7) {
                return true;
            }
        }

        return false;
    }

    /**
     * Controlla a selezione della cella
     * @param key indice cella
     */
    checkElement(key: string): boolean {
        if (!this.checkUserPermission() || this.week.confirmed) return false;
        if (this.selected_week_element.length == 0) return false;

        if (this.selected_week_element.indexOf(key) > -1)
            return true;

        return false;
    }

    /**
     * Inserisce i giorni nei casi speciali
     * @param type 0 = single day, 1 = am, 2 = pm
     */
    toggleSpecialSelectedElement(type: number, day_number?: number): void {
        if (!this.checkUserPermission() || this.week.confirmed) return;

        if (type == 0) {
            let day = [day_number + '_am', day_number + '_pm'];
            if (this.selected_week_element.indexOf(day[0]) > -1 && this.selected_week_element.indexOf(day[1]) > -1) {
                this.removeArrayElement(day[0]);
                this.removeArrayElement(day[1]);
            } else {
                if (this.selected_week_element.indexOf(day[0]) == -1) {
                    this.selected_week_element.push(day[0]);
                }
                if (this.selected_week_element.indexOf(day[1]) == -1) {
                    this.selected_week_element.push(day[1]);
                }
            }
        } else if (type == 1) {
            let days = ['1_am', '2_am', '3_am', '4_am', '5_am', '6_am', '7_am'];
            let counter = 0;
            for (const key of days) {
                if (this.selected_week_element.indexOf(key) > -1) {
                    counter = counter + 1;
                }
            }
            if (counter == 7) {
                for (const key of days) {
                    this.removeArrayElement(key);
                }
            } else {
                for (const key of days) {
                    if (this.selected_week_element.indexOf(key) == -1) {
                        this.selected_week_element.push(key);
                    }
                }
            }
        } else if (type == 2) {
            let days = ['1_pm', '2_pm', '3_pm', '4_pm', '5_pm', '6_pm', '7_pm'];
            let counter = 0;
            for (const key of days) {
                if (this.selected_week_element.indexOf(key) > -1) {
                    counter = counter + 1;
                }
            }
            if (counter == 7) {
                for (const key of days) {
                    this.removeArrayElement(key);
                }
            } else {
                for (const key of days) {
                    if (this.selected_week_element.indexOf(key) == -1) {
                        this.selected_week_element.push(key);
                    }
                }
            }
        }
    }

    toggleSelectedElement(element: string): void {
        if (!this.checkUserPermission() || this.week.confirmed) return;

        let newArray: string[] = [];
        let present = false;
        for (const key of this.selected_week_element) {
            if (key == element)
                present = true;
            else
                newArray.push(key);
        }

        if (!present)
            newArray.push(element);

        this.selected_week_element = newArray;
    }

    countSelected(): number {
        return this.selected_week_element.length;
    }

    removeArrayElement(element: string): void {
        let newArray: string[] = [];
        for (const key of this.selected_week_element) {
            if (key != element)
                newArray.push(key);
        }

        this.selected_week_element = newArray;
    }

    confirmWeek() {
        if (!this.network.verifyConnection()) {
            this.coreService.showToast(Messages.offline, 'bottom');
        } else {

            let alert = this.alertCtrl.create({
                title: "<b>" + Messages.week_confirm + "</b><br><br>" + Messages.hr_confirm,
                cssClass: 'alert-week',
                buttons: [
                    {
                        text: 'Cancel',
                        role: 'cancel'
                    },
                    {
                        text: 'OK',
                        handler: () => {
                            this.coreService.confirmWeek(this.user_data.key);
                        }
                    }
                ]
            });
            alert.present();
        }
    }

    unlockWeek() {
        if (!this.network.verifyConnection()) {
            this.coreService.showToast(Messages.offline, 'bottom');
        } else {
            let alert = this.alertCtrl.create({
                title: 'Week Unlock',
                cssClass: 'alert-week',
                buttons: [
                    {
                        text: 'Cancel',
                        role: 'cancel'
                    },
                    {
                        text: 'OK',
                        handler: () => {
                            this.coreService.unlockWeek(this.user_data.key);
                        }
                    }
                ]
            });
            alert.present();
        }
    }

    getName(key: string): string {

        for (let i of this.coreService.getListUsers()) {
            if (i.key == key) {
                return i.name;
            }
        }
        return key;

    }

    getDate(date: string): Date {

        let date_new = date.split(' ')[0];
        let date_array = date_new.split('-');

        return new Date(date_array[2] + ' ' + date_array[1] + ' ' + date_array[0]);

    }

    /**
     * Show note se Travel
     * Verifica stato in base al testo
     */
    checkNote(txt: string): boolean {
        let showNote = true;
        for (let i of legendaStati) {
            if (txt == i) {
                showNote = false;
                break;
            }
        }

        for (let i of this.coreService.getLeaveLabel()) {
            if (txt == i) {
                showNote = false;
                break;
            }
        }

        return showNote;
    }

    /**
     * Show modal Edit
     */
    showModalEdit() {
        if (!this.network.verifyConnection()) {
            this.coreService.showToast(Messages.offline, 'bottom');
        } else {
            if (this.countSelected() > 0) {
                let profileModal = this.modalCtrl.create(ModalEditPage, { selected: this.selected_week_element, userkey: this.user_data.key, week: this.week });

                profileModal.present();

                profileModal.onWillDismiss(end => {
                    this.selected_week_element = [];
                });
            }
        }
    }

    /**
     * Visualizza colore stato in base al valore passato
     */
    stateView(value: string): string {
        let statusLabel = {
            "Headquarter": "cellStyleHeadQuarter",
            "Bank Holiday": "cellStyleHoliday",
            "Travel": "cellStyleTravel",
        };

        for (let i in statusLabel) {
            if (value == i) {
                return statusLabel[i];
            } else if (this.coreService.getLeaveLabel().indexOf(value) > -1) {
                return "cellStyleLeave";
            }
        }

        return statusLabel.Travel;

    }

    defineWeekDays(): Array<string> {

        let firstWeekDay = new Date(this.week_range[0]);
        let baseWeekDay = new Date(this.week_range[0]);

        return [
            new DatePipe("en").transform(new Date(baseWeekDay), 'd MMM y'),
            new DatePipe("en").transform(new Date(baseWeekDay).setDate(firstWeekDay.getDate() + 1), 'd MMM y'),
            new DatePipe("en").transform(new Date(baseWeekDay).setDate(firstWeekDay.getDate() + 2), 'd MMM y'),
            new DatePipe("en").transform(new Date(baseWeekDay).setDate(firstWeekDay.getDate() + 3), 'd MMM y'),
            new DatePipe("en").transform(new Date(baseWeekDay).setDate(firstWeekDay.getDate() + 4), 'd MMM y'),
            new DatePipe("en").transform(new Date(baseWeekDay).setDate(firstWeekDay.getDate() + 5), 'd MMM y'),
            new DatePipe("en").transform(new Date(baseWeekDay).setDate(firstWeekDay.getDate() + 6), 'd MMM y'),
        ];

        ;
    }

}



// WEBPACK FOOTER //
// ./src/pages/time-reporting/time-reporting.ts